import React, { useState, useEffect, Fragment, Container } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Card, CardBody, Button } from 'reactstrap';
import EventIcon from '@material-ui/icons/Event';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'moment-timezone';
// pick a date util library
import MomentUtils from '@date-io/moment';
import "moment/locale/es";
import AppointmentAssignmentModal from './AppointmentAssignmentModal';
import EventComponent from './EventComponent.jsx';
import TextField from '@material-ui/core/TextField';
import Spinner from 'react-bootstrap/Spinner';
import WeekComponent from './WeekComponent';
import DayComponent from './DayComponent';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import CalendarToolbar from './CalendarToolbar';
import DiaryAgendaReportPDF from '../Reports/exports/pdf/DiaryAgendaReportPDF';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import ReportsApi from '../Reports/api/reports_api';
import IconButton from '@material-ui/core/IconButton';
import ListRequestRescheduleModal from './ListRequestRescheduleModal';
import axios from 'axios';

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#3EA3FC',
      contrastText: "#fff",
      color: 'white'
    },
  },
});

const localizer = momentLocalizer(moment);

const DragAndDropCalendar = withDragAndDrop(Calendar);

let viewMode = "day";

const formats = {
  dayFormat: (date, culture) => localizer.format(date, 'DD', culture),
  agendaTimeRangeFormat: range => `${localizer.format(range.start, 'h:mm a')} – ${localizer.format(range.end, 'h:mm a')}`,
  agendaDateFormat: range => `${localizer.format(range.start, 'YYYY/MM/DD')}`,
};

const CalendarComponent = ({ small, events: propEvents, dir, setDateSelected }) => {

  const [events, setEvents] = useState([]);
  const [step, setStep] = useState(30);
  const [selectedDay, setDay] = useState(new Date());
  const [professional, setProfessional] = useState(null);
  const [specialties, setSpecialties] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const [openEvent, setOpenEvent] = useState(false);
  const [dataEvent, setDataEvent] = useState({});
  const [referenceDate, setReferenceDate] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [viewModeState, setViewModeState] = useState('day');
  const [typeAppointment, setTypeAppointment] = useState(null);
  const [showPDF, setShowPDF] = useState(false);
  const [atentionsAgenda, setAtentionsAgenda] = useState([]);
  const [atentionAgenda, setAtentionAgenda] = useState(null);
  const [typeServices, setTypeServices] = useState([]);
  const [modalRequestReschedule, setModalRequestReschedule] = useState(false);
  const [dataReschedule, setDataReschedule] = useState([]);

  useEffect(() => {
    loadEvents(new Date(moment().tz("America/Bogota")), professional, typeAppointment, atentionAgenda);
    loadTypeAgendas();
    loadTypeService();
    loadDataProfessionals();
    loadSpecialities();
  }, []);

  const loadTypeAgendas = async () => {
    await fetch(`${process.env.REACT_APP_PUBLIC_URL}atencion/listar`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error('Error');
      }
    }).then(data => {
      setAtentionsAgenda(data);
    }).catch(err => {
      setAtentionsAgenda([]);
    });
  }

  const loadTypeService = async () => {
    await fetch(`${process.env.REACT_APP_PUBLIC_URL}servicio-tipo/listar`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error('Error');
      }
    }).then(data => {
      setTypeServices(data);
    }).catch((error) => {
      console.log(error);
      setTypeServices([]);
    });
  }


  const loadEvents = async (date, professional, typeAppointmentAgenda, atentionAgenda) => {

    let id_agenda_activa = 0;//Este anteriormente era un filtro que venia de Profeisonal, OJO !!

    //Si esta en 0 se consulta todas
    if (typeAppointmentAgenda == null || typeAppointmentAgenda == undefined) {
      typeAppointmentAgenda = 0;
    }

    console.log(professional);

    setIsLoading(true);
    setReferenceDate(date);//Toma la fecha de Referencia para gestionarlo con los Filtros Avanzados
    let dateCalendar = new Date(date);
    let viewSearch = "";
    let dateStart = null;
    let dateEnd = null;
    switch (viewMode) {
      case 'month':
        dateStart = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth(), 1);
        dateEnd = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth() + 1, 0);
        viewSearch = 'mensual';
        break;
      case 'day':
        dateStart = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth(), dateCalendar.getDate());
        dateEnd = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth(), dateCalendar.getDate() + 1);
        viewSearch = 'diaria';
        break;
    }
    let idAgendaActiva = id_agenda_activa != null && id_agenda_activa != undefined ? id_agenda_activa : 0;
    let dataDate = {
      f_inicio: !!dateStart ? moment(dateStart).format("YYYY/MM/DD") : moment(new Date()).format("YYYY/MM/DD"),
      f_fin: !!dateStart ? moment(dateEnd).format("YYYY/MM/DD") : moment(new Date()).format("YYYY/MM/DD"),
      id: idAgendaActiva,
      vista: viewSearch,
      tipo_cita: typeAppointmentAgenda,
      id_profesional: professional != undefined && professional != null ? professional.id_profesional : null,
      id_atencion: atentionAgenda
    }
    if (dataDate.id != null) {
      try {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultar', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
          },
          body: JSON.stringify(dataDate)
        }).then((response) => {
          if (response.status != 500 && response.status != 403 && response.status != 404) {
            return response.json();
          }
          else {
            throw new Error("Ha ocurrido un error consultando la agenda");
          }
        }).then((data) => {
          if (data.existe) {

            setDateSelected(dateStart);

            if (data.contenido instanceof Array) {
              var jornadas = data.contenido;
              jornadas.map((jornada) => {
                jornada.start = new Date(jornada.start);
                jornada.end = new Date(jornada.end);
                jornada.id_agenda = jornada.hasOwnProperty("id_agenda") ? jornada.id_agenda : idAgendaActiva;
              });
              if (jornadas.length > 0) {
                setStep(10);
              }
              setEvents(jornadas);
              setIsLoading(false);
            } else if (data.contenido instanceof String) {
              setIsLoading(false);
            }
          } else {
            setIsLoading(false);
            setEvents([]);
          }
        }).catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
      } catch (e) {
        setIsLoading(false);
      }
    } else {
      setEvents([]);
      setIsLoading(false);
    }
  }

  const loadDataProfessionals = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
      method: 'GET',
      headers: {
        authorization: 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(professionals => {
        setProfessionals(professionals);
      })
      .catch((error) => {

      });
  };

  const loadSpecialities = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
      method: 'GET',
      headers: {
        authorization: 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(specialists => {
        setSpecialties(specialists);
      })
      .catch((error) => {

      });
  };


  const moveEvent = ({ event, start, end }) => {
    const idx = events.indexOf(event);
    const updatedEvent = { ...event, start, end };

    const nextEvents = [...events];
    nextEvents.splice(idx, 1, updatedEvent);
    setEvents(nextEvents);
  };

  const eventStyleGetter = (event) => {
    let color;

    switch (event.priority) {
      case 'Reservada':
        color = '#fd7e14'; //orange
        break;
      case 'Cumplida':
        color = '#28a745'; //success
        break;
      case 'Incumplida':
        color = '#f6da6e'; //yellow
        break;
      case 'Emergencia':
        color = '#dc3545'; //danger
        break;
      case 'Disponible':
        color = '#70bbfd'; //primary
        break;
      case 'Inactiva':
        color = '#6c757d'; //gray
        break;
      default:
        color = '$color-additional';
        break;
    }

    const style = {
      backgroundColor: color,
      border: 'none',
    };

    return {
      style,
    };
  };

  const updateModalEventAppointmentData = (event, showMoreEvent) => {
    setDataEvent(event);
    setOpenEvent(true);
  }

  const getViewMode = () => {
    return viewMode;
  }

  const handleChangeOnViewCalendar = async (view) => {
    viewMode = view;
    setViewModeState(view);
    await loadEvents(selectedDay, professional, typeAppointment, atentionAgenda);
  }

  const handleChangeTypeAppointment = async (type) => {
    setTypeAppointment(type);
    loadEvents(selectedDay, professional, type, atentionAgenda);
  }

  const handlerTypeAgenda = async (atAgenda) => {
    setAtentionAgenda(atAgenda);
    await loadEvents(selectedDay, professional, typeAppointment, atAgenda);
  }

  const showRequestReschedule = async () => {
    await getListRequestReschedule().then((reschedule) => {
      setModalRequestReschedule(true);
    });
  }

  const exportAgendaToPdf = async () => {
    let filtroReport = null;
    let ReportOperationDiary = [];
    let fechaInicial = moment(selectedDay).format('YYYY/MM/DD');
    let fechaFinal = moment(selectedDay).format('YYYY/MM/DD');
    let id_profesional = professional != null && professional != undefined ? professional.id_profesional : null

    console.log("medicoProfessional", professional);
    filtroReport = {
      "fecha_inicio": moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
      "fecha_final": moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
      "id_tercero": null,
      "tipo_agenda": atentionAgenda,
      "id_profesional": id_profesional != null && id_profesional != undefined ? id_profesional : null,
      "tipo_cita": typeAppointment
    }
    ReportOperationDiary = await ReportsApi.operationsDiary(filtroReport);
    if (ReportOperationDiary.length > 0) {
      let clinica = JSON.parse(sessionStorage.getItem('clinica'));
      let obj = {
        items: ReportOperationDiary,
        profile: clinica,
        title: "Agenda del Dia",
        fecha_seleccionada: selectedDay,
        fecha_reportada: moment(selectedDay).format("DD/MM/YYYY")
      }
      setShowPDF(true);
      await DiaryAgendaReportPDF(obj);
    }
    else {
      alert("No se encontraron datos para generar este Reporte");
    }
    return ReportOperationDiary;
  }

  const getListRequestReschedule = async () => {
    await fetch(`${process.env.REACT_APP_PUBLIC_URL}agenda/listar-reagendamiento`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403 && response.status != 404) {
        return response.json();
      }
      else {
        throw new Error('Error');
      }
    }).then(data => {
      setDataReschedule(data);
    }).catch(err => {
      console.log(err);
      setDataReschedule([]);
    });
  }

  return (
    <Fragment>
      <Row>
        <Col md={9}>
          <Card>
            <CardBody>
              <div className={`calendar${small ? ' calendar--small' : ''}`} >
                <Row>
                  <Col md={2} xs={2}>
                    <p className="typography-message">
                      <span className="calendar-label calendar-label--orange" />Reservada
                    </p>
                  </Col>
                  <Col md={2} xs={2}>
                    <p className="typography-message">
                      <span className="calendar-label calendar-label--success" />Cumplida
                    </p>
                  </Col>
                  <Col md={2} xs={2}>
                    <p className="typography-message">
                      <span className="calendar-label calendar-label--yellow" />Incumplida
                    </p>
                  </Col>
                  <Col md={2} xs={2}>
                    <p className="typography-message">
                      <span className="calendar-label calendar-label--danger" />Emergencia
                    </p>
                  </Col>
                  <Col md={2} xs={2}>
                    <p className="typography-message">
                      <span className="calendar-label calendar-label--blue" />Disponible
                    </p>
                  </Col>
                  <Col md={2} xs={2}>
                    <p className="typography-message">
                      <span className="calendar-label calendar-label--gray" />Inactivar
                    </p>
                  </Col>
                </Row>
                <br />
                { isLoading == false ? <div>
                    <DragAndDropCalendar
                      rtl={dir === 'rtl'}
                      localizer={localizer}
                      events={events}
                      getViewMode={getViewMode}
                      views={{
                        month: true,
                        // week: WeekComponent,
                        day: DayComponent
                      }}
                      popup
                      formats={formats}
                      step={step}
                      timeslots={1}
                      showMultiDayTimes
                      onView={(view) => {
                        handleChangeOnViewCalendar(view);
                      }}
                      defaultView={viewModeState}
                      onEventDrop={moveEvent}
                      date={selectedDay}
                      onNavigate={date => {
                        setDay(date);
                        loadEvents(date, professional, typeAppointment, atentionAgenda);
                      }}
                      eventPropGetter={eventStyleGetter}
                      messages={{
                        month: "Mes",
                        showMore: function showMore(total) {
                          return '+' + total + ' mas';
                        },
                        date: "Fecha",
                        event: "Cita Medica",
                        time: "Hora",
                        day: "Dia",
                        week: "Semana",
                        doctor: "Profesional",
                        patient: "Paciente",
                        noEventsInRange: ''
                      }}
                      dayLayoutAlgorithm={'no-overlap'}
                      components={
                        {
                          toolbar: props => (
                            <CalendarToolbar {...props}
                              updateModalEventAppointmentData={updateModalEventAppointmentData}
                              referenceDate={referenceDate}
                              exportAgendaToPdf={exportAgendaToPdf}
                              showRequestReschedule={showRequestReschedule}
                              dataReschedule={dataReschedule}
                            />),
                          event: (event) => { return (<EventComponent event={event.event} setData={updateModalEventAppointmentData} getViewMode={getViewMode} />) }
                        }}
                      onSelectEvent={(event) => { updateModalEventAppointmentData(event) }}
                    />
                  </div>
                    :
                    <div className="text-center">
                      <Spinner animation="border" variant="success" />
                    </div>
                }
              </div>
              {openEvent ?
                <AppointmentAssignmentModal
                  handlerClose={setOpenEvent}
                  openEvent={openEvent}
                  dataEvent={dataEvent}
                  reload={loadEvents}
                  typeAppointment={typeAppointment}
                  professional={professional}
                  selectedDay={selectedDay}
                  atentionAgenda={atentionAgenda}
                /> : null}
            </CardBody>
          </Card>
        </Col>
        <Col md={3}>
          <div>
            <Card>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <ThemeProvider theme={defaultMaterialTheme}>
                  <DatePicker
                    autoOk
                    disableToolbar={true}
                    variant="static"
                    value={selectedDay}
                    onChange={(date) => {
                      setDay(new Date(date));
                      loadEvents(new Date(date), professional, typeAppointment, atentionAgenda);
                    }}
                    format="DD/MM/yyyy"
                    style={{ textAlign: "center" }}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Card>
          </div>
          <div>
            <Card>
              <CardBody>
                <h3 className="page-subhead subhead">Filtrar agenda</h3>
                <form className="material-form" >
                  <TextField
                    className="material-form__field"
                    label="Profesional"
                    id="id-simplep-select"
                    style={{ width: '100%', marginRight: 20 }}
                    select
                    value={professional}
                    defaultValue={0}
                    onChange={(event) => {
                      setProfessional(event.target.value);
                      loadEvents(selectedDay, event.target.value, typeAppointment, atentionAgenda);
                    }}
                  >
                    <MenuItem key={0} value={null}>Todos</MenuItem>
                    {professionals.map((professional) => {
                      return <MenuItem key={professional.id_profesional} value={professional}>
                        {!!professional.sexo ? professional.sexo === 'Femenino' ? 'DRA. ' : professional.sexo === 'Masculino' ? 'DR. ' : '' : ''}{professional.nombres + ' ' + professional.apellido1}
                      </MenuItem>
                    })}
                  </TextField>

                  <TextField
                    className="material-form__field"
                    label="Tipo de Agenda"
                    id="id-simplee-select"
                    style={{ width: '100%', }}
                    select
                    defaultValue={0}
                    value={atentionAgenda}
                    onChange={(event) => {
                      handlerTypeAgenda(event.target.value)
                    }}
                  >
                    <MenuItem key={0} value={0}>Ninguna</MenuItem>
                    {atentionsAgenda.map((typeA) => {
                      return <MenuItem key={typeA.id_atencion} value={typeA.id_atencion}>{typeA.atencion}</MenuItem>
                    })}
                  </TextField>

                  <TextField
                    className="material-form__field"
                    label="Tipo de Cita"
                    id="id-simplee-select"
                    style={{ width: '100%', }}
                    select
                    defaultValue={0}
                    value={typeAppointment}
                    onChange={(event) => {
                      handleChangeTypeAppointment(event.target.value);
                    }}
                  >
                    <MenuItem value={""}>Sin Filtro</MenuItem>
                    {typeServices.map((typeSer) => {
                      return <MenuItem key={typeSer.id_servicio_tipo} value={typeSer.id_servicio_tipo}>{typeSer.nombre}</MenuItem>
                    })}
                  </TextField>
                </form>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
      <br />
      <br />
      {showPDF ?
        <Modal
          open={showPDF}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
            <IconButton style={{ float: 'right' }} onClick={() => {
              setShowPDF(false);
            }}>
              <CloseIcon />
            </IconButton>

            <iframe id="pdfV" width="1000" height="700" >
            </iframe>
          </div>
        </Modal>
        : null}

      <ListRequestRescheduleModal
        opened={modalRequestReschedule}
        closeModal={() => setModalRequestReschedule(false)}
        setDataEvent={updateModalEventAppointmentData}
        CallbackReschedule={getListRequestReschedule}
        CallbackCalendar={() => {
          if (selectedDay != null) {
            loadEvents(new Date(moment().tz("America/Bogota")), professional, typeAppointment, atentionAgenda);
          }
        }}
        dataReschedule={dataReschedule}
        atentionAgenda={atentionAgenda}
        typeAppointment={typeAppointment}
        professional={professional}
        selectedDay={selectedDay}
      />

    </Fragment>
  );
};

CalendarComponent.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    allDay: PropTypes.bool,
    start: PropTypes.instanceOf(Date),
    end: PropTypes.instanceOf(Date),
    priority: PropTypes.string,
  })).isRequired,
  small: PropTypes.bool,
  dir: PropTypes.string.isRequired,
};

CalendarComponent.defaultProps = {
  small: false,
};

export default CalendarComponent;
